export default "__VITE_ASSET__Dr1yLA9s__"